const useNumber = () => {
  const toNumber = (val: string): number => Number(val.replace(/[^\d.-]+/g, ''));

  return {
    toNumber,
  };
};

export default useNumber;
